import { useContext } from 'react';
import MessagesContext from '../contexts/messagesContext';

const usePermissions = () => {
    const { messages } = useContext(MessagesContext);

    const permissions = [
        {
            id: 2,
            name: 'write_demographic',
            title: messages.permissionsTitle.write_demographic,
            description: messages.permissionsDesc.write_demographic,
            mainAccess: [1, 2, 5, 7, 6, 8],
            patientAccess: [5, 6],
            settingAccess: []
        },
        {
            id: 3,
            name: 'read_clinical',
            title: messages.permissionsTitle.read_clinical,
            description: messages.permissionsDesc.read_clinical,
            mainAccess: [1, 2, 5, 6, 7],
            patientAccess: [1, 2, 3, 4, 5, 6],
            settingAccess: []
        },
        {
            id: 4,
            name: 'write_clinical',
            title: messages.permissionsTitle.write_clinical,
            description: messages.permissionsDesc.write_clinical,
            mainAccess: [1, 2, 5, 6, 7],
            patientAccess: [1, 2, 3, 4],
            settingAccess: []
        },
        {
            id: 5,
            name: 'aggregate_data',
            title: messages.permissionsTitle.aggregate_data,
            description: messages.permissionsDesc.aggregate_data,
            mainAccess: [1, 2, 3, 4, 5, 6, 7],
            patientAccess: [5, 6],
            settingAccess: [2]
        },
        {
            id: 6,
            name: 'manage_form',
            title: messages.permissionsTitle.manage_form,
            description: messages.permissionsDesc.manage_form,
            mainAccess: [1, 2, 5, 6, 7],
            patientAccess: [5, 6],
            settingAccess: [1]
        },
        {
            id: 7,
            name: 'manage_clinic',
            title: messages.permissionsTitle.manage_clinic,
            description: messages.permissionsDesc.manage_clinic,
            mainAccess: [1, 2, 5, 6, 7],
            patientAccess: [5, 6],
            settingAccess: [4]
        },
        {
            id: 8,
            name: 'manage_user',
            title: messages.permissionsTitle.manage_user,
            description: messages.permissionsDesc.manage_user,
            mainAccess: [1, 2, 5, 6, 7],
            patientAccess: [5, 6],
            settingAccess: [3]
        }
    ];

    const titles = [
        {
            id: 0,
            title: messages.user
        },
        {
            id: 1,
            title: messages.clinics
        },
        ...permissions
    ];

    return { permissions, titles };
};

export default usePermissions;
